import { Component } from '@angular/core';

@Component({
  selector: 'app-refresh',
  standalone: true,
  imports: [],
  templateUrl: './refresh.component.html',
  styleUrl: './refresh.component.css',
})
export class RefreshComponent {
  constructor() {
    history.back();
  }
}
